import { PricingPlan } from '@/constants/enum';
import { PATH } from '@/constants/path';
import { Box, Button } from '@shopify/polaris';
import { useNavigate } from 'react-router-dom';

export const PlanMessage = ({ plan }: { plan: PricingPlan }) => {
  const navigate = useNavigate();
  switch (plan) {
    case PricingPlan.Essential:
      return (
        <Box>
          This feature is only available{' '}
          <Button variant="plain" onClick={() => navigate(PATH.PRICING.pathname)}>
            with the Essential Plan or higher
          </Button>{' '}
        </Box>
      );
    case PricingPlan.Smart:
      return (
        <Box>
          This feature is only available{' '}
          <Button variant="plain" onClick={() => navigate(PATH.PRICING.pathname)}>
            with the Smart Plan or higher
          </Button>{' '}
        </Box>
      );
    case PricingPlan.Enterprise:
      return (
        <Box>
          This feature is only available{' '}
          <Button variant="plain" onClick={() => navigate(PATH.PRICING.pathname)}>
            with the Enterprise Plan
          </Button>{' '}
        </Box>
      );
  }
};
